<template>
    <div class="system-main">
        <SystemNavbar></SystemNavbar>
        <router-view/>
    </div>
</template>

<script>
import SystemNavbar from './components/navbar.vue';

export default {
    components: {
        SystemNavbar
    },
    data() {
        return {};
    }
};
</script>



// WEBPACK FOOTER //
// src/views/system/system.vue